import Vue from 'vue'
import {
  Vuetify,
  VApp,
  VNavigationDrawer,
  VFooter,
  VList,
  VBtn,
  VIcon,
  VGrid,
  VToolbar,
  transitions,
  VCard,
  VTooltip,
  VForm,
  VTextField,
  VSwitch,
  VDivider,
  VBreadcrumbs,
  VDataTable,
  VCheckbox,
  VCombobox,
  VSelect,
} from 'vuetify'
import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
  components: {
    VApp,
    VNavigationDrawer,
    VFooter,
    VList,
    VBtn,
    VIcon,
    VGrid,
    VToolbar,
    VCard,
    VTooltip,
    VForm,
    VTextField,
    VSwitch,
    VDivider,
    VBreadcrumbs,
    VDataTable,
    VCheckbox,
    VCombobox,
    VSelect,
    transitions
  },
  theme: {
    primary: '#0D47A1',
    secondary: '#e1e1e1',
    accent: '#8c9eff',
    error: '#b71c1c'
  },
})
